import { useEffect } from 'react';
// redux
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
// Reveal
import Reveal from 'reveal.js';
// imagenes
import logoMATUC from '../../../../img/logo_matuc.png';
// LaTeX
import Latex from 'react-latex-next';

import '../../../../css/reveal.css';
import '../../../../css/math.css';
import '../../../../css/diapositivas.css';
import { SeccionState } from '../../../../store/slices/seccion';
import { BloqueState } from '../../../../store/slices/bloque';


type Props = {
    seccion: SeccionState
    bloque: BloqueState
}

const Diapositivas = ({seccion, bloque}: Props) => {

    const { curso } = useSelector((state: RootState) => state.curso);

    useEffect(() => {
        let deck = new Reveal({
            // hash: true,
            controlsLayout: 'edges',
            center: false,
            backgroundTransition: 'slide',
            transition: 'slide',
            margin: 0.05,
            width: '1280',
            height: '800',
            minScale: 0.2,
            maxScale: 2.0
        })
        deck.initialize({
            // slideNumber: 'c/t',
            // math: {
            //     config: 'TeX-AMS_HTML-full',
            //     TeX: {
            //         Macros: {
            //             R: '\\mathbb{R}',
            //             alo: '\\mathcal{A}',
            //             set: [ '\\left\\{#1 \\; ; \\; #2\\right\\}', 2 ]
            //         }
            //     }
            // },
        });
        console.log('initialized fool')
    },[seccion])

    return (
        <div className="reveal" 
            style={{
                background: '#f7f2d3',
                backgroundColor: '#f7f3de',
                minHeight: '100vh'
            }}
        >
            <div className="slides">

                {/* PORTADA */}

                <section data-transition="slide" className='center'>
                    
                    <div className="row align-items-center justify-content-center">
                        <div className="col-7">
                            <h1 style={{fontSize: '2.5em', marginBottom: '1em'}}>{curso.nombre}</h1>
                            <Latex>{`<h4 style="font-size: 1.3em">${bloque.nombre}</h4>`}</Latex>
                            <h4 style={{fontSize: '0.9em', marginTop: '2em'}}>
                                {seccion.autor}
                            </h4>
                        </div>
                        <div className="col-5">
                            {/* <img src={logoMATUC} alt="logo uc" /> */}
                        </div>
                    </div>

                </section>

                {
                    seccion?.diapositivas &&
                    seccion?.diapositivas.map((item, key) => {
                        const { contenido } = item;
                        return (
                            <section 
                                data-transition="slide" 
                                data-align='center' 
                                style={{display: 'block', textAlign: 'justify'}} 
                                key={key}
                            >
                                <Latex>{contenido}</Latex>
                            </section>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default Diapositivas